<template>
  <el-drawer
    class="sideDrawer"
    destroy-on-close
    :size="drawerSize"
    :close-on-click-modal="false"
    title="订单"
    append-to-body
    :visible="show"
    :before-close="beforeCloseDialog"
    @dialogclose="beforeCloseDialog"
  ><i
      class="iconfont icon-back-quanping iconFull"
      @click="drawerSize = '100%'"
      v-if="drawerSize == '70%'"
    />
    <i
      @click="drawerSize = '70%'"
      class="iconfont icon-back-tuichuquanping iconFull"
      v-else
    />
    <div
      slot="title"
      class="dialog-header-title"
    >
      <span class="name">订单</span>
    </div>
    <div
      class="form_content"
      style="padding: 20px"
    >
      <el-form
        :model="formData"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-row class="form_head_title">
          
          客户信息
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="订单编号:"
              prop="order_no"
            >
              <el-input
                v-model="formData.order_no"
                placeholder="保存后自动生成"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="订单日期:"
              prop="order_time"
            >
              <el-date-picker
                v-model="formData.order_time"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"
                disabled
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="客户名称:"
              prop="customer_name"
            >
              <el-input
                v-model="formData.customer_name"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="创建人:"
              prop="create_user"
            >
              <el-input
                v-model="formData.create_user"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="联系人:"
              prop="contacts"
            >
              <el-input
                v-model="formData.contacts"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="联系电话:"
              prop="contacts_phone"
            >
              <el-input
                v-model="formData.contacts_phone"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="form_head_title">
          
          订单信息
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="产品名称:"
              prop="account_name"
            >
              <el-input
                v-model="formData.account_name"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="目前状态:"
              prop="account_status"
            >
              <el-select
                style="width: 100%"
                v-model="formData.account_status"
                placeholder="请选择"
                disabled
              >
                <el-option
                  v-for="item in cellStatusList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="套餐名称:"
              prop="contacts_package"
            >
              <el-input
                v-model="formData.contacts_package"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="订单金额:"
              prop="order_amount"
            >
              <el-input
                v-model="formData.order_amount"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="充值时间(年):"
              prop="recharge_years"
            >
              <el-input
                v-model="formData.recharge_years"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="购买用户数:"
              prop="users_number"
            >
              <el-input
                v-model="formData.users_number"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="购买次数(次):"
              prop="purchases_number"
            >
              <el-input
                v-model="formData.purchases_number"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          label="备注:"
          prop="remark"
        >
          <el-input
            v-model="formData.remark"
            disabled
          ></el-input>
        </el-form-item>
        <el-row class="form_head_title">
          订单确认
        </el-row>
        <el-table :data="tableData">
          <el-table-column
            prop="reviewer_results"
            label="审核状态"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.reviewer_results == 0"
                style="color:#FF4F4F"
              >
                审核不通过</span>
              <span
                v-if="scope.row.reviewer_results == 1"
                style="color:#1EA103"
              >
                审核通过</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="reviewer_name"
            label="审核人"
          >
          </el-table-column>
          <el-table-column
            prop="reviewer_phone"
            label="联系电话"
          >
          </el-table-column>
          <el-table-column
            prop="audit_date"
            label="审核时间"
          >
          </el-table-column>
          <el-table-column
            prop="remark"
            label="审核意见"
          > </el-table-column>
        </el-table>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
import utils from '@/utils.js'
import * as constants from './constants'
export default {
  data() {
    return {
      drawerSize: '70%',
      formData: {
        order_no: '',
        order_time: '',
        customer_name: '',
        customer_id: '',
        create_user: '',
        contacts: '',
        contacts_phone: '',
        account_key: '',
        account_name: '',
        account_status: '',
        contacts_package: '',
        remark: '',
        recharge_years: 0,
        users_number: 0,
        purchases_number: 0,
        order_amount: 0
      },
      tableData: [],
      ...constants
    }
  },
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    orderId: {
      type: String,
      default: () => ''
    }
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.loadData()
        }
      },
      deep: true
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (this.orderId) {
        this.$http.get('${third}/costcenter/third_order/' + this.orderId).then((res) => {
          if (res.data) {

            if (res.data.account_status) {
              res.data.account_status = parseFloat(res.data.account_status)
            }
            if (res.data.order_amount) {
              res.data.order_amount = utils.dataTransform(res.data.order_amount)
            } else res.data.order_amount = 0
            if (res.data.recharge_years) {
              res.data.recharge_years = utils.dataTransform(res.data.recharge_years)
            } else res.data.recharge_years = 0
            if (res.data.users_number) {
              res.data.users_number = utils.dataTransform(res.data.users_number)
            } else res.data.users_number = 0
            if (res.data.purchases_number) {
              res.data.purchases_number = utils.dataTransform(res.data.purchases_number)
            } else res.data.purchases_number = 0
            this.formData = res.data
            this.tableData = res.data.orderConfirmList
          }
        })
      }
    },
    //关闭dialog
    beforeCloseDialog() {
      this.$emit('closeOrderRecord')
    }
  }
}
</script>
<style scoped>
.dialog-header-title {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.dialog-header-title > span {
  border-left: 3px solid #2761ff;
  font-weight: 700;
  font-size: 14px;
  padding-left: 10px;
  color: #666;
}
/deep/.el-dialog__body {
  padding: 10px 20px 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.botton_button {
  display: flex;
  text-align: center;
  justify-content: center;
}
.form_head_title {
  height: 35px;
  color: #377cff;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
</style>
